import React from "react";
import { NavLink } from "react-router-dom";

const BreadCrames = ({page}) => {
  return (
   
      <ol class="breadcrumb px-4 py-2 border-bottom">
        <li class="breadcrumb-item">
            <NavLink to="/dashboard">
                    Home
            </NavLink>
        
        </li>
    
        <li class="breadcrumb-item active" aria-current="page">
            {page}
        </li>
      </ol>

  );
};

export default BreadCrames;
